import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Svg from '@bibliocommons/svg';

import './DisplayBibStencil.scss';

const DisplayBibStencil = ({ className }) => {
  return (
    <article className={cn('cp-display-bib-stencil', className)}>
      <div className="jacket-wrapper">
        <div className="jacket-inner">
          <Svg className="pulse jacket-placeholder" viewBox="0 0 100% 100%">
            <rect height="100%" x="0" y="0" width="100%" />
          </Svg>
        </div>
        <div className="icon-placeholder"></div>
      </div>

      <Svg className="title pulse">
        <rect height="100%" x="0" y="0" width="100%" />
      </Svg>
    </article>
  );
};

DisplayBibStencil.defaultProps = {
  className: ''
};

DisplayBibStencil.propTypes = {
  className: PropTypes.string
};

export default DisplayBibStencil;
